<div class="flex flex-col w-full gap-[6px]">
    <span class="font-[500] text-[14px] text-[#6B7280]">{{ label }}</span>
    <div class="w-full flex items-center gap-[10px]">
        <div (click)="setItem(item)" *ngFor="let item of items" class="border-[1.5px] px-[8px] py-[3px] cursor-pointer {{selectedItem === item ? 'border-[#081A46]' : 'border-border-gray-300'}} rounded-[5px]"><span class="text-[14px] {{selectedItem === item ? 'text-[#081A46] font-[600]' : 'text-gray-300 font-[400]'}}">{{item}}</span></div>
    </div>
    <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>